import { get } from 'lodash'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import PaymentMethodManager from '@apis/paymentMethod/PaymentMethodManager'
import { updateCompanySuccess } from '../../actions/currentUser'

const initialState = {
  loading: false,
  error: null,
}

export const putPaymentMethod = createAsyncThunk('paymentMethod/putPaymentMethod', async ({ payload, companyId }, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await PaymentMethodManager.putPaymentMethod(payload, companyId)
    if (!response.error) {
      const existing_company = getState().currentUser.currentUser.company
      const new_company = {
        ...existing_company,
        ...payload,
        payment_methods: response.company.payment_methods,
        missing_payment_method: response.company.missing_payment_method,
      }

      dispatch(updateCompanySuccess(new_company))
    }

    return response
  } catch (err) {
    return rejectWithValue(get(err, 'response.data'))
  }
})

const fetching = (state) => {
  state.loading = true
  state.error = null
}

const fetchSuccess = (state, action) => {
  state.loading = false
  state.error = null
}

const fetchFailure = (state, action) => {
  state.loading = false
  state.error = action.payload
}

const paymentMethodSlice = createSlice({
  name: 'paymentMethod',
  initialState,
  extraReducers: {
    [putPaymentMethod.pending]: fetching,
    [putPaymentMethod.fulfilled]: fetchSuccess,
    [putPaymentMethod.rejected]: fetchFailure,
  },
})

export default paymentMethodSlice.reducer
